<template>
    <div>
        <!--General Top Bar -->
        <!-- <general-top-bar :title="$t('dispath.settings')" class="mar-bt-0"></general-top-bar> -->
        <!--End General Top Bar -->
        <div id="outer-container">
            <div ref="navButtons" class="card mar-bt-0 mar-to-10 max-z-index navButtons">
                <div class="card-content">
                    <div class="clearfix row pad-lf-10 pad-rg-10">
                        <a
                          class="btn btn-fill btn-primary"
                          :class="{ active: isGeneral }"
                          @click="openGeneral"
                        >{{$t('dispath.general')}}</a>
                        <a
                          class="btn btn-fill btn-primary"
                          :class="{ active: isUsers }"
                          @click="openUsers"
                        >{{$t('dispath.users')}}</a>
                        <a
                          class="btn btn-fill btn-primary"
                          :class="{ active: isDispatchers }"
                          @click="openDispatchers"
                        >{{$t('dispath.dispatchers')}}</a>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="isGeneral">
            <div class="card">
                <div class="card-content">
                  <form class="clearfix row">
                        <div class="col-md-12">
                            <div class="auto-dispatch">
                              <div class="form-group mar-bt-0" style="display: flex;">
                                  <label>{{$t('settingCompany.use_auto_dispatch')}}</label>
                                  <br/>
                                  <p-switch
                                      v-model="autoDispatch"
                                      type="success"
                                      style="margin-left: 10px;">
                                  </p-switch>
                              </div>
                              <div v-if="autoDispatch" class="info-text">
                                {{$t('settingCompany.autoModeText')}}
                              </div>
                              <div v-else class="info-text">
                                {{$t('settingCompany.manualModeText')}}
                              </div>
                            </div>
                            <div v-if="autoDispatch" class="auto-dispatch-automated">
                              <div class="form-group mar-to-15 mar-bt-0" style="display: flex;">
                                  <label>{{$t('settingCompany.autoGroupingByZone')}}</label>
                                  <p-switch v-model="autoGroupingByZone" type="success" style="margin-left: 10px;"></p-switch>
                              </div>
                              <div class="form-group mar-bt-0" style="display: flex;">
                                  <label>{{$t('settingCompany.newOrdersProcessing')}}</label>
                                  <p-switch v-model="newOrdersProcessing" type="success" style="margin-left: 10px;"></p-switch>
                              </div>
                              <div class="form-group mar-bt-0" style="display: flex;">
                                  <label>{{$t('settingCompany.preparedStatus')}}</label>
                                  <p-switch v-model="preparedStatus" type="success" style="margin-left: 10px;"></p-switch>
                              </div>
                            </div>
                            <div class="form-group mar-to-15" style="display: flex;">
                                <label>{{$t('dispath.walletSettings')}}</label>
                                <br/>
                                <p-switch
                                    v-model="walletSettings"
                                    type="success"
                                    style="margin-left: 10px;">
                                </p-switch>
                            </div>
                            <div class="form-group mar-to-15" style="display: flex;">
                                <label>{{$t('dispath.disableUndeliveredOrder')}}</label>
                                <br/>
                                <p-switch
                                    v-model="disableUndeliveredOrder"
                                    type="success"
                                    style="margin-left: 10px;">
                                </p-switch>
                            </div>
                            <div class="form-group" style="display: flex; margin-bottom: 0px;">
                                <label>
                                    <a href="https://drive.google.com/drive/u/2/folders/1zCCGg2I_lsFfkqH4JPFT2A5pB9w2CaUi" target="_blank">{{$t('dispath.downloadApp')}}</a>
                                </label>
                            </div>
                        </div>
                  </form>
                </div>
            </div>
        </div>
        <div v-if="isUsers">
            <div class="card mar-to-15">
                <div class="card-content">
                    <div class="text-right">
                        <p>
                            <button class="btn add mar-rt-10"  @click="goToAdd" :title="$t('general.add') + ' ' + $t('settingUsers.single')">
                                <img src="/static/img/icons/add.png">
                                {{$t('general.add')}}
                            </button>
                        </p>
                    </div>
                    <data-tables
                        v-loading="loading"
                        :data="filteredTableData"
                        ref="userList"
                        :search-def="{}"
                        :pagination-def="{}"
                        :table-props="{'border': false}"
                        @row-click="goToRecord"
                        style="width: 100%">
                        <el-table-column v-for="column in tableColumns"
                                        :key="column.label"
                                        :min-width="column.minWidth"
                                        :prop="column.prop"
                                        :label="column.label"
                                        sortable>
                        </el-table-column>
                        <el-table-column :min-width="150" prop="role" :label="$t('settingUsers.role')" >
                            <template slot-scope="props">
                                {{$t('settingUsers.' + props.row.role)}}
                            </template>
                        </el-table-column>
                        <el-table-column :width="145">
                            <template slot-scope="props">
                                <div class="edit" @click="goToRecord(props.row, $event)">
                                  <i class="fa fa-pencil"></i>{{$t('general.edit')}}
                                </div>
                            </template>
                        </el-table-column>
                    </data-tables>
                </div>
            </div>
        </div>
        <div v-if="isDispatchers">
            <div class="card mar-to-15">
                <div class="card-content">
                    <div class="text-right">
                        <p>
                            <button class="btn add mar-rt-10"  @click="goToAddDispatcher" :title="$t('general.add') + ' ' + $t('settingUsers.DISPATCHER')">
                                <img src="/static/img/icons/add.png">
                                {{$t('general.add')}}
                            </button>
                        </p>
                    </div>
                    <data-tables
                        v-loading="loading"
                        :data="filteredDispatchersData"
                        ref="dispatcherList"
                        :search-def="{}"
                        :pagination-def="{}"
                        :table-props="{'border': false}"
                        @row-click="goToRecord"
                        style="width: 100%">
                        <el-table-column v-for="column in tableColumns"
                                        :key="'d-' + column.label"
                                        :min-width="column.minWidth"
                                        :prop="column.prop"
                                        :label="column.label"
                                        sortable>
                        </el-table-column>
                        <el-table-column :min-width="150" prop="role" :label="$t('settingUsers.role')" >
                            <template slot-scope="props">
                                {{$t('settingUsers.' + props.row.role)}}
                            </template>
                        </el-table-column>
                        <el-table-column :width="145">
                            <template slot-scope="props">
                                <div class="edit" @click="goToRecord(props.row, $event)">
                                  <i class="fa fa-pencil"></i>{{$t('general.edit')}}
                                </div>
                            </template>
                        </el-table-column>
                    </data-tables>
                </div>
            </div>
        </div>
    </div>
</template>

  <script>
  import Vue from 'vue'
  // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import {Input, Table, TableColumn, Option, Pagination} from 'element-ui'
  import DataTables from 'vue-data-tables'
  import PPagination from 'src/components/UIComponents/Pagination.vue'

  Vue.use(Input)
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Option)
  Vue.use(Pagination)
  Vue.use(DataTables)
  export default {
    components: {
      PPagination,
      // GeneralTopBar,
      [Input.name]: Input,
      PSwitch
    },
    props: {
      callback: {
        required: false
      },
      callbackAdd: {
        required: false
      }
    },
    data () {
      return {
        loading: false,
        isGeneral: true,
        isUsers: false,
        isDispatchers: false,
        tableColumns: [
          {
            prop: 'firstname',
            label: this.$t('settingUsers.fn'),
            minWidth: 100
          },
          {
            prop: 'lastname',
            label: this.$t('settingUsers.ln'),
            minWidth: 100
          }
        ],
        tableData: [],
        autoDispatch: false,
        walletSettings: false,
        disableUndeliveredOrder: false,
        autoGroupingByZone: false,
        newOrdersProcessing: false,
        preparedStatus: false
      }
    },
    computed: {
      filteredTableData () {
        return this.tableData.filter(user => user.role === 'DRIVER' || user.role === 'DISPATCHER')
      },
      filteredDispatchersData () {
        return this.tableData.filter(user => user.role === 'DISPATCHER')
      }
    },
    mounted () {
      this.$bus.$on('refresh', this.handleRefresh)
    },
    beforeDestroy () {
      this.$bus.$off('refresh', this.handleRefresh)
    },
    created () {
      this.getUsers()
      this.getSettings()

      this.$bus.$on('refresh', this.handleRefresh)
    },
    watch: {
      autoDispatch (newValue) {
        this.updateSetting('use_auto_dispatch', newValue)
      },
      walletSettings (newValue) {
        this.updateSetting('has_wallet_in_version', newValue)
      },
      disableUndeliveredOrder (newValue) {
        this.updateSetting('disable_undelivered_order', newValue)
      }
    },
    methods: {
      handleRefresh () {
        this.getUsers()
      },
      openGeneral () {
        this.isGeneral = true
        this.isUsers = false
        this.isDispatchers = false
      },
      openUsers () {
        this.isUsers = true
        this.isGeneral = false
        this.isDispatchers = false
      },
      openDispatchers () {
        this.isDispatchers = true
        this.isUsers = false
        this.isGeneral = false
      },
      globalGoToRecord (row, event, path) {
        const userId = row.id
        this.$router.push(`${path}${userId}`)
      },
      goToRecord (row, event) {
        if (typeof this.callback === 'function') {
          this.callback(row.id)
        } else {
          this.globalGoToRecord(row, event, '/user/edit/')
        }
      },
      getUsers () {
        var self = this
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/profile', 'GET', data, function (response) {
          if (response.status === true) {
            self.tableData = response.data

            self.$nextTick(function () {
              self.loading = false
            })
          }
        })
      },
      getSettings () {
        var self = this
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/dispatch-get-settings', 'GET', data, function (response) {
          if (response.status === true) {
            self.autoDispatch = response.data.use_auto_dispatch === 1
            self.walletSettings = response.data.has_wallet_in_version === 1
            self.disableUndeliveredOrder = response.data.disable_undelivered_order === 1
            self.loading = false
          }
        })
      },
      updateSetting (setting, value) {
        const data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          [setting]: value ? 1 : 0
        }

        this.apiRequest('/dispatch-set-settings', 'POST', data, (response) => {
          if (response.status === true) {
          } else {
          }
        })
      },
      goToAdd () {
        this.$router.push({ path: '/user/add', query: { from: 'dispatchSettings' } })
      },
      goToAddDispatcher () {
        this.$router.push({ path: '/user/add', query: { from: 'dispatcherSettings' } })
      }
    }
  }
  </script>

  <style>
  .el-date-editor .el-range-separator {
    padding: 0 2px;
  }
  #outer-container .navButtons .card-content {
    padding-left: 0px;
  }
  .el-table .cell {
    height: 55px;
  }
  .pull-right.legend {
    margin-top: 15px;
    cursor: pointer;
    text-decoration: underline;
  }
  .info-text {
    font-size: 13px;
    font-weight: 400;
    color: #000;
    background-color: white;
    padding: 7px 10px;
    border-radius: 9px;
    box-shadow: 0 6px 10px -4px rgba(0, 0, 0, 0.1);
  }
  </style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Dispatch/DispatchSettings.vue